export default __webpack_public_path__ + "static/media/list_type.5f6b2670.svg";